<template>
    <div @click="toggleSelected(!value)" class="type" :class="{ selected: type.selected }">{{ type['label_' + $i18n.locale] }} <b>{{ '('+type.nb+')' }}</b> </div>
</template>

<script>

export default {
  props: ['type', 'value'],
  computed: {
    selected () {
      return this.type.selected
    }
  },
  methods: {
    toggleSelected (newValue) {
      this.type.selected = !this.type.selected
      this.$emit('input', newValue)
    }
  }
}
</script>

<style>
.type {
  cursor: pointer;
  opacity: 0.2;
  padding: 4px 25px;
  text-align: left;
}
.type.selected {
  opacity: 1;
}

.filter-icon {
  margin-right: 10px;
  color: white;
  border-radius: 50%;
  border: solid white 1px;
  padding: 6px;
}

</style>
